var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExcavator(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1355_1487)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 20,
    r: 13,
    fill: "#F2F2F2"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.4 24.1429C24.4 23.7629 24.0942 23.4571 23.7142 23.4571C23.3342 23.4571 23.0285 23.7629 23.0285 24.1429C23.0285 24.5229 23.3342 24.8286 23.7142 24.8286C24.0942 24.8286 24.4 24.5229 24.4 24.1429Z",
    fill: "#132439"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26 24.8286C26.38 24.8286 26.6857 24.5229 26.6857 24.1429C26.6857 23.7629 26.38 23.4571 26 23.4571C25.62 23.4571 25.3142 23.7629 25.3142 24.1429C25.3142 24.5229 25.62 24.8286 26 24.8286Z",
    fill: "#132439"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9714 24.1429C28.9714 23.7629 28.6657 23.4571 28.2857 23.4571C27.9057 23.4571 27.6 23.7629 27.6 24.1429C27.6 24.5229 27.9057 24.8286 28.2857 24.8286C28.6657 24.8286 28.9714 24.5229 28.9714 24.1429Z",
    fill: "#132439"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5714 24.8286C30.9514 24.8286 31.2571 24.5229 31.2571 24.1429C31.2571 23.7629 30.9514 23.4571 30.5714 23.4571C30.1914 23.4571 29.8857 23.7629 29.8857 24.1429C29.8857 24.5229 30.1914 24.8286 30.5714 24.8286Z",
    fill: "#132439"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.0028 19.6486L30.5057 12.1057C30.2171 11.4371 29.5571 11 28.8257 11H25.3142C24.5571 11 23.9428 11.6143 23.9428 12.3714V21.2571H23.4857C21.7142 21.2571 20.2857 22.8657 20.2857 24.1429C20.2857 25.9114 21.7171 27.3429 23.4857 27.3429H30.8C32.5685 27.3429 33.9999 25.9114 33.9999 24.1429C33.9999 23.6514 33.8885 23.1857 33.6914 22.7714L33.0857 20.9429V20.0486C33.0885 19.98 33.0799 19.9114 33.0685 19.8457C33.0571 19.78 33.0342 19.7114 33.0057 19.6514L33.0028 19.6486ZM30.7857 19.1143L28.8257 12.8286H25.7714V17.2857L27.6 19.1143H30.7857ZM32.1714 24.1429C32.1714 23.3857 31.5571 22.7714 30.8 22.7714H23.4857C22.7285 22.7714 22.1142 23.3857 22.1142 24.1429C22.1142 24.9 22.7285 25.5143 23.4857 25.5143H30.8C31.5571 25.5143 32.1714 24.9 32.1714 24.1429Z",
    fill: "#132439"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7142 23.4571C24.0942 23.4571 24.4 23.7629 24.4 24.1429C24.4 24.5229 24.0942 24.8286 23.7142 24.8286C23.3342 24.8286 23.0285 24.5229 23.0285 24.1429C23.0285 23.7629 23.3342 23.4571 23.7142 23.4571ZM31.2571 24.1429C31.2571 24.5229 30.9514 24.8286 30.5714 24.8286C30.1914 24.8286 29.8857 24.5229 29.8857 24.1429C29.8857 23.7629 30.1914 23.4571 30.5714 23.4571C30.9514 23.4571 31.2571 23.7629 31.2571 24.1429ZM28.2857 23.4571C28.6657 23.4571 28.9714 23.7629 28.9714 24.1429C28.9714 24.5229 28.6657 24.8286 28.2857 24.8286C27.9057 24.8286 27.6 24.5229 27.6 24.1429C27.6 23.7629 27.9057 23.4571 28.2857 23.4571ZM26.6857 24.1429C26.6857 24.5229 26.38 24.8286 26 24.8286C25.62 24.8286 25.3142 24.5229 25.3142 24.1429C25.3142 23.7629 25.62 23.4571 26 23.4571C26.38 23.4571 26.6857 23.7629 26.6857 24.1429Z",
    fill: "#132439"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6153 15.2751C19.259 14.918 18.6812 14.918 18.3248 15.2751C17.9685 15.6321 17.9685 16.211 18.3248 16.5681L23.6289 21.8823L24.9194 20.5894L19.6153 15.2751Z",
    fill: "#132439"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6149 16.5681C19.9713 16.211 19.9713 15.6321 19.6149 15.2751C19.2585 14.918 18.6808 14.918 18.3244 15.2751L13.6458 19.9627C13.2891 20.3201 13.2891 20.8995 13.6458 21.2569L14.2905 21.9028L19.6149 16.5681Z",
    fill: "#132439"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9033 21.8921L20.5479 21.2463C20.9046 20.8889 20.9046 20.3094 20.5479 19.952L17.1259 16.5234L15.8354 17.8164L19.9033 21.8921Z",
    fill: "#132439"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2572 21.8814C15.0074 22.6342 16.0248 23.0571 17.0857 23.0571C18.1465 23.0571 19.1639 22.6342 19.9141 21.8814L18.7836 20.7468C18.3332 21.1987 17.7225 21.4526 17.0857 21.4526C16.4488 21.4526 15.8381 21.1987 15.3878 20.7468L14.2572 21.8814Z",
    fill: "#132439"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1355_1487",
    x: 12,
    y: 7,
    width: 26,
    height: 27,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1355_1487"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcavator);
export default __webpack_public_path__ + "static/media/excavator.dab753017229c297cea3c72dafbff5f1.svg";
export { ForwardRef as ReactComponent };